module.exports = __webpack_public_path__ + "img/hehu-1.880cad99.png";